import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { useSelector } from "react-redux";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler
);
const RLineTrends = (props) => {
  const items = useSelector((state) => state.userDetailsData.LoginDetails);

  const [RPTrends, SetRPTrends] = useState();
  const [SelectR, SetSelectR] = useState();
  const USYear = useSelector((state) => state.SelecYearData.SYear);
  const RegionalPerformanceTrends = async (RegionId) => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/InstitutionAdmin/GetRegionalPerformanceTrendsByInstitute?Year=${USYear?.value}&AssessmentType=${props.AType}&InstituteId=${items?.instituteId}&RegionId=${RegionId}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0].assessmentDate) {
          SetRPTrends(res.data);
          SetSelectR(RegionId);
          const subjects = [
            ...new Set(res.data.map((item) => item.subjectName)),
          ];
          props.StoreSubjects(subjects);
          props.StoreSelSub(subjects[0]);
        } else {
          SetRPTrends(process.env.REACT_APP_NODATAFOUND_Participated);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if( props.AType){
    RegionalPerformanceTrends(
      props.SelectedRegion?.RegionId ||
        SelectR ||
        props.Regions?.[0]?.value ||
        1
    );}
  }, [SelectR,props.AType, props.SelectedRegion?.RegionId, USYear]);

  const labels = [];
  const Subjects = {};

  if (RPTrends?.[0].assessmentDate) {
    RPTrends?.forEach((item) => {
      if (
        !labels.includes(item.assessmentDate) &&
        props.SubSelect === item.subjectName
      ) {
        labels.push(item.assessmentDate);
      }
      if (!Subjects[item.subjectName]) {
        Subjects[item.subjectName] = [];
      }
    });
    RPTrends?.forEach((item) => {
      Subjects[item.subjectName].push(item.percentage);
    });
  }

  const datasets = Object.keys(Subjects).map((Subject) => ({
    label: Subject,
    data: Subjects[props.SubSelect],
    // fill: "origin",
    // fill: {
    //   target: "origin", // Set the fill options
    //   // above: "rgba(255, 0, 0, 0.3)"
    // },
    // borderColor: 'rgb(75, 192, 192)',
    // tension: 0.5,
    backgroundColor:
      {
        English: "#7C60BC",
        Mathematics: "#00A2B9",
        Science: "#3DA663",
        Biology: "#F7C66A",
        BioTechnology: "#A63D95",
        "Physics and Chemistry": "#3B9ED7",
      }[(Subject, props.SubSelect)] || "#000",
    borderColor:
      {
        English: "#7C60BC",
        Mathematics: "#00A2B9",
        Science: "#3DA663",
        Biology: "#F7C66A",
        BioTechnology: "#A63D95",
        "Physics and Chemistry": "#3B9ED7",
      }[(Subject, props.SubSelect)] || "#000",
    maxBarThickness: 40,
    barThickness: 45,
  }));

  const data = { labels: labels, datasets: datasets };

  const options = {
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: function (context) {
            if (context.dataset.label === props.SubSelect) {
              const label = context.dataset.label || "";
              const value =
                context.parsed.y !== null ? context.parsed.y + "%" : "";
              return `${label}: ${value}`;
            }
            return null;
          },
        },
      },
    },
    scales: {
      x: {
        offset: 1,
        grid: { display: false },
        title: { display: true, text: "Assessment Date" },
      },
      y: {
        title: { display: true, text: "Performance %" },
        beginAtZero: true,
        max: 100,
      },
    },
  };
  return (
    <>
      <div className="SubHeading mb-2">
        Regionwise performance{" "}
        {props.SelectedRegion && `- ${props.SelectedRegion?.RegionName}`}
      </div>
      {RPTrends?.[0].assessmentDate ? (
        <>
          {!props.SelectedRegion && (
            <div className="dflex JSAround Region-Navigations">
              {props.Regions?.map((item, index) => (
                <span
                  key={index}
                  onClick={() => {
                    SetSelectR(item.value);
                  }}
                  style={
                    parseInt(SelectR) !== item.value
                      ? {
                          color: "#878997",
                          textDecoration: "underline #878997",
                        }
                      : {}
                  }
                >
                  {item.display}
                </span>
              ))}
            </div>
          )}
          {labels.length !== 0 ? (
            <Line options={options} data={data} />
          ) : (
            <div className="ErrorMessage">
              {process.env.REACT_APP_NODATAFOUND_Participated}
            </div>
          )}
        </>
      ) : (
        <div className="ErrorMessage">{RPTrends}</div>
      )}
    </>
  );
};
export default RLineTrends;
